export default theme => {
    return window && window.innerWidth && theme && theme.breakpoints && theme.breakpoints && theme.breakpoints.values &&  theme.breakpoints.values.md >= window.innerWidth
}